import { createShortUrl } from '../services';
import LZString from 'lz-string';

export const createShortUrlAndRedirect = async (
  currentUrlToRedirect: string,
  pageName: string
) => {
  // Check exists
  if (currentUrlToRedirect) {
    const resultUrl = await createShortUrl(currentUrlToRedirect);
    const pathname = window.location.pathname.split('/');
    const languageParam = pathname[1];
    window.location.href = `/MyDigiKey${pageName}?returnUrl=${window.location.origin}/${languageParam}/cross-reference/${resultUrl.id}`;
  }
};

export const setSelectedPartAndUpdateIntoUrl = (
  selectedNodes: any,
  currentUrl: string,
  updateUrl: (suffixUrl: string) => void
) => {
  let selectedData = selectedNodes
    .filter((node: any) => node.data && !node.rowPinned)
    .map((node: any) => node.data);

  let selectedPinnedData = selectedNodes
    .filter((node: any) => node.data && node.rowPinned)
    .map((node: any) => node.data);

  const urlParamsSelectedPart = new URLSearchParams(
    new URL('', currentUrl).search
  );
  const decodedParams = new URLSearchParams(
    '?' +
    LZString.decompressFromEncodedURIComponent(
      urlParamsSelectedPart.get('s')!
    )
  );

  const selectedDataIds: { partID: number; isMarketplace: boolean }[] = [];
  selectedData.forEach((element: any) => {
    selectedDataIds.push({
      partID: element.productId,
      isMarketplace: element.isMarketPlace
    });
  });
  //push productId and isMarketPlace to selectedData to decode to sString
  selectedPinnedData.forEach((element: any) => {
    const elementMarketPlace = element.productVariations.filter((x: any) => x.isMarketPlace)
    selectedDataIds.push({
      partID: elementMarketPlace[0]?.productId ?? element.productId,
      isMarketplace: elementMarketPlace[0]?.isMarketPlace !== undefined ? elementMarketPlace[0]?.isMarketPlace : (element.isMarketPlace ?? false)
    });
  });

  decodedParams.set('selectedDataIds', JSON.stringify(selectedDataIds));

  updateUrl(
    `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
  );
};

export const restorePartSelected = (
  selectedPartBeforeLogin: any,
  gridApi: any
) => {
  if (
    selectedPartBeforeLogin &&
    selectedPartBeforeLogin.length > 0 &&
    gridApi &&
    !gridApi.destroyCalled
  ) {
    gridApi.forEachNode((node: any) => {
      // check exists
      if (node.data) {
        const isSelected: boolean = selectedPartBeforeLogin.some(
          (data: any) =>
            node.data.productId === data.partID &&
            node.data.isMarketPlace === data.isMarketplace
        );
        node.setSelected(isSelected);
      }
    });
  }
};

export const restorePartSelectedWhenReturningFromComparePage = (
  selectedPartBeforeLogin: any,
  gridApi: any
) => {
  if (
    selectedPartBeforeLogin &&
    selectedPartBeforeLogin.length > 0 &&
    gridApi &&
    !gridApi.destroyCalled
  ) {
    gridApi.forEachNode((node: any) => {
      // check exists
      if (node.data) {
        const isSelected: boolean = selectedPartBeforeLogin.some(
          (data: any) => node.data.productIdCompared === data
        );
        node.setSelected(isSelected);
      }
    });
  }
};
